export default {
  body: {
    id: 'bundle_small_to_modal_body',
    defaultMessage: 'Both for {totalPrice}',
  },
}
